var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creator-card"},[_c('details',[_c('summary',[_vm._v(_vm._s(_vm.creator.name))]),_c('p',[_vm._v(_vm._s(_vm.creator.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }